import PropTypes from 'prop-types'
import { Link } from 'wouter'

// Match robusto para rutas - CORREGIDO para manejar la ruta raíz
const isRouteActive = (currentPath, targetPath) => {
  const cur = String(currentPath || '').trim()
  const tgt = String(targetPath || '').trim()

  if (!tgt) return false
  
  // Caso especial: ruta raíz debe ser exacta
  if (tgt === '/') {
    return cur === '/'
  }
  
  // Para otras rutas: exact match o prefijo
  if (cur === tgt) return true
  if (cur.startsWith(tgt.endsWith('/') ? tgt : `${tgt}/`)) return true

  return false
}

export default function SubMenuItems({ submenu, location, isSidebarOpen }) {
  const nowrap = !isSidebarOpen ? 'whitespace-nowrap' : ''

  const baseClasses =
    'inline-flex pr-3 pl-4 ml-2.5 py-1.5 text-base text-white duration-300 grow border-s-0 hover:border-s-2 hover:border-[#FCAE52] hover:text-[#FCAE52]'

  const isActive = isRouteActive(location, submenu?.slug)

  return (
    <li className="flex" title={submenu?.title} key={submenu?.title}>
      <Link
        href={submenu.slug}
        className={`${baseClasses} ${nowrap} ${isActive ? '*:text-[#FCAE52] border-s-2 border-[#FCAE52]' : ''}`}
      >
        <div className="w-1/6">{submenu?.icon}</div>

        <div
          className={`w-5/6 ml-3 flex items-center uppercase origin-left duration-75 ${
            !isSidebarOpen ? 'scale-0' : ''
          }`}
        >
          <span>{submenu?.title}</span>
        </div>
      </Link>
    </li>
  )
}

SubMenuItems.propTypes = {
  submenu: PropTypes.object,
  location: PropTypes.any,
  isSidebarOpen: PropTypes.any
}